<template>
    <v-row>
        <v-col>
            <v-text-field
                :label="$gettext('Server')"
                :placeholder="$gettext('Server')"
                required
                v-model="ftpServer"
                outlined
                clearable
                disabled
            ></v-text-field>
            <v-text-field
                :label="$gettext('Username')"
                :placeholder="$gettext('Username')"
                required
                v-model="ftpUsername"
                :rules="[v => !!v || 'Username is required']"
                outlined
                clearable
            ></v-text-field>

            <v-text-field
                :label="$gettext('Password')"
                :placeholder="$gettext('Password')"
                required
                v-model="ftpPassword"
                :rules="[v => !!v || 'Password is required']"
                outlined
                clearable
                type="password"
            ></v-text-field>
        </v-col>
    </v-row>
</template>
<style type="text/scss">

</style>
<script>

import {storeToRefs} from "pinia";
import {useLoginStore} from "@/stores/LoginStore";

export default {
    name: 'FtpModeLoginForm',
    setup() {

        const loginStore = useLoginStore()
        const {
            ftpServer,
            ftpUsername,
            ftpPassword,
        } = storeToRefs(loginStore);

        return {
            ftpServer,
            ftpUsername,
            ftpPassword,
        }

    }
}


</script>
